<template>
    <nav>
        <v-layout>
            <v-toolbar dark flat app>
              <v-toolbar-side-icon class="hidden-md-and-up" @click="toggleDrawer" />
                <v-toolbar-title>
                    <a href="\" class="font-weight-bold  word-three ira-title">Ірина Семененко</a>
                </v-toolbar-title>

            <v-spacer></v-spacer>
                
            <v-btn class="menu-btn hidden-sm-and-down text-capitalize font-weight-bold" flat v-for="link in links" :key="link.text" @click="$vuetify.goTo(link.href, options)">
                <span class="mr-2">{{ link.text }}</span>
                    </v-btn>     
        </v-toolbar>
      <Drawer :drawer="drawer" />
    </v-layout>
  </nav>
</template>

<script>
  import Drawer from '@/components/Drawer'
  import * as easings from 'vuetify/es5/util/easing-patterns'

export default {
    name: 'Header',
    components: {
    Drawer
  },
  data () {
    return {
      dialog: false,
      easings: Object.keys(easings),
      drawer: false,
      links: [
        {text: 'Про артиста', href: '#about'},
        {text: 'Фотогалерея', href: '#gallery'},  
        {text: 'Преса', href: '#pressa'}, 
        {text: 'Відео', href: '#videos'},
        {text: 'Контакти', href: '#contacts'}                                                
      ]
    }
  },
  computed: {
    target () {
      const value = this[this.type]
        if (!isNaN(value)) return Number(value)
        else return value
      },
    options () {
      return {
        duration: 900,
        offset: 0,
        easing: 'easeInOutCubic'        
      }
    }
  },
  methods: {
      toggleDrawer() {
        this.drawer = !this.drawer
    }
  }
}
</script>

<style>
    .menu-btn {
        font-size: 24px;
        letter-spacing: 1px;
        color: rgb(160, 158, 158)!important;
        font-family: 'Open Sans Condensed', sans-serif;
        font-style: normal;
        font-weight: normal;
    }
    .ira-title {
       color: rgb(160, 158, 158)!important;
    }
</style>
